module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理企业信息变更一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、《公司登记（备案）申请书》","state":"必要"},{"name":"2、变更登记事项涉及公司章程修改的，提交修改公司章程的决议或者决定","state":"非必要"},{"name":"3、变更登记事项涉及公司章程修改的，提交修改后的公司章程或者公司章程修正案","state":"非必要"},{"name":"4、变更事项相关证明文件","state":"非必要"},{"name":"5、法律、行政法规和国务院决定规定公司变更事项必须报经批准的，提交有关的批准文件或者许可证件","state":"非必要"},{"name":"6、《确认诉讼文书送达地址承诺书》","state":"非必要"},{"name":"7、已领取纸质版营业执照的缴回营业执照正、副本","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx34.json
// module id = 1331
// module chunks = 0